import { UserRole } from '@/core/models/user.model';
import { SidebarGroup } from '@/shared/components/sidebar/sidebar.interface';
import {
  CORA_DASHBOARD_ROLES,
  CORA_PENDING_ROLES,
  CORA_LIST_ROLES,
  CORA_CREATE_ROLES,
  CORA_MY_CORAS_ROLES,
  ASC_SIEGE_ROLES,
  ASC_AGENCE_ROLES,
  ASC_CREATE_ROLES,
  ASC_PENDING_ROLES,
  ASC_CHEQUES_ROLES,
  ASC_LIST_ROLES,
  ASC_ALL,
  CREDIT_SIEGE_ROLES,
  CREDIT_AGENCE_ROLES,
  CREDIT_CREATE_ROLES,
  CREDIT_LIST_ROLES,
  CREDIT_EMPLOYEUR_ROLES,
  CREDIT_ALL,
  PARAMS_ROLES,
  ACCESS_TRACK_ROLES,
  EXTRACTION_ROLES,
} from '@/core/constants/access-roles';

const { Admin, AdministrationAudit: ADMIN_AUDIT } = UserRole;


/** Littéralement tous les rôles — dérivé de l'enum pour ne jamais en oublier un. */
const ALL_ROLES = [...new Set(Object.values(UserRole))] as const;

export const DEFAULT_MENU: SidebarGroup[] = [
  {
    label: 'Power Bi',
    icon: 'ellipsis',
    // Aucune restriction : quasiment tous les rôles y ont accès dans l'old frontend
    items: [
      {
        label: 'Tableau de bord',
        href: '/app/power-bi/dashboard',
        icon: 'layout-dashboard',
        roles: [...ALL_ROLES],
      },
    ],
  },
  {
    label: 'Reseau de CORA',
    icon: 'ellipsis',
    items: [
      {
        label: 'Tableau de bord',
        href: '/app/cora/dashboard',
        icon: 'layout-dashboard',
        roles: [...CORA_DASHBOARD_ROLES],
      },
      {
        label: 'Créer un CORA',
        href: '/app/cora/create',
        icon: 'user-plus',
        roles: [...CORA_CREATE_ROLES],
      },
      {
        label: 'Detail Cora',
        href: '/app/cora/',
        icon: 'user',
        roles: [],
      },
      {
        label: 'Créer un sous-agent',
        href: '/app/cora/agent/create',
        icon: 'user-plus',
        roles: [...CORA_CREATE_ROLES],
      },
      {
        label: 'Detail sous-agent',
        href: '/app/cora/agent/',
        icon: 'user',
        roles: [],
      },
      {
        label: 'Demandes en attente',
        href: '/app/cora/pending',
        icon: 'clock',
        roles: [...CORA_PENDING_ROLES],
      },
      { label: 'Liste des CORAs', href: '/app/cora/list', icon: 'list', roles: [...CORA_LIST_ROLES] },
      { label: 'Mes CORAs', href: '/app/cora/my-coras', icon: 'users', roles: [...CORA_MY_CORAS_ROLES] },
      {
        label: 'Géolocalisation CORA',
        href: '/connexion/geolocalisation-des-cora',
        icon: 'map-pin',
        roles: [Admin],
      },
    ],
  },
  {
    label: 'Avance sur chèque',
    icon: 'ellipsis',
    items: [
      {
        label: 'Tableau de bord',
        href: '/app/asc/dashboard',
        icon: 'layout-dashboard',
        roles: [...ASC_SIEGE_ROLES],
      },
      {
        label: 'Tableau de bord agence',
        href: '/app/asc/dashboard/agence',
        icon: 'layout-dashboard',
        roles: [...ASC_AGENCE_ROLES],
      },
      {
        label: 'Nouvelle demande',
        href: '/app/asc/client-search',
        icon: 'search',
        roles: [...ASC_CREATE_ROLES],
      },
      {
        label: 'Detail de la demande',
        href: '/app/asc/detail',
        icon: 'folder-open',
        roles: [],
      },
      {
        label: 'Detail du cheque',
        href: '/app/asc/cheque',
        icon: 'folder-open',
        roles: [...ASC_ALL],
        hidden: true,
      },
      {
        label: 'Demandes en attente',
        href: '/app/asc/pending',
        icon: 'clock',
        roles: [...ASC_PENDING_ROLES],
      },
      {
        label: 'Chèques en cours (7j)',
        href: '/app/asc/cheques-attente',
        icon: 'alarm-clock',
        roles: [...ASC_CHEQUES_ROLES],
      },
      {
        label: 'Liste des chèques',
        href: '/app/asc/list',
        icon: 'list',
        roles: [...ASC_LIST_ROLES],
      },
      {
        label: 'Liste des tireurs',
        href: '/app/asc/tireurs',
        icon: 'users',
        roles: [...ASC_LIST_ROLES],
      },
    ],
  },
  {
    label: 'Crédit',
    icon: 'credit-card',
    items: [
      {
        label: 'Tableau de bord',
        href: '/app/credit/dashboard',
        icon: 'layout-dashboard',
        roles: [...CREDIT_SIEGE_ROLES],
      },
      {
        label: 'Tableau de bord agence',
        href: '/app/credit/dashboard-agence',
        icon: 'layout-dashboard',
        roles: [...CREDIT_AGENCE_ROLES],
      },
      {
        label: 'Nouvelle demande',
        href: '/app/credit/create',
        icon: 'file-plus',
        roles: [...CREDIT_CREATE_ROLES],
      },
      {
        label: 'Liste des demandes',
        href: '/app/credit/list',
        icon: 'list',
        roles: [...CREDIT_LIST_ROLES],
      },
      {
        label: 'Detail de la demande',
        href: '/app/credit',
        icon: 'folder-open',
        roles: [...CREDIT_ALL],
        hidden: true,
      },
      {
        label: "Detail de l'agence",
        href: '/app/credit/detail-agence',
        icon: 'building',
        roles: [...CREDIT_ALL],
        hidden: true,
      },
      {
        label: 'Résumé de la demande',
        href: '/app/credit/resume/',
        icon: 'folder-open',
        roles: [...CREDIT_ALL],
        hidden: true,
      },
      {
        label: 'Analyse financiere de la demande',
        href: '/app/credit/analyse/',
        icon: 'folder-open',
        roles: [...CREDIT_ALL],
        hidden: true,
      },
      // {
      //   label: 'Tirages découvert',
      //   href: '/app/credit/tirage/list',
      //   icon: 'credit-card',
      //   roles: [...CREDIT_TIRAGE_ROLES],
      // },
      {
        label: 'Employeurs',
        href: '/app/credit/employeur/list',
        icon: 'users',
        roles: [...CREDIT_EMPLOYEUR_ROLES],
      },
      {
        label: 'Detail employeur',
        href: '/app/credit/employeur/',
        icon: 'user',
        roles: [],
      },
    ],
  },
  {
    label: 'AccessTrack',
    icon: 'shield-alert',
    // hideNewFeature: true,
    items: [
      {
        label: 'Tableau de bord',
        href: '/app/access-track/dashboard',
        icon: 'layout-dashboard',
        roles: [Admin],
      },
      {
        label: 'Vue Client 360°',
        href: '/app/access-track/vue-client',
        icon: 'circle-user',
        roles: [...ACCESS_TRACK_ROLES],
      },
      {
        label: 'Remboursement/Recouvrement',
        href: '/app/access-track/vue-credit',
        icon: 'folder-open',
        roles: [Admin],
      },
      {
        label: 'Actions planifiées',
        href: '/app/access-track/planification',
        icon: 'alarm-clock',
        roles: [...ACCESS_TRACK_ROLES],
      },
      {
        label: 'Reporting',
        href: '/app/access-track/reportings',
        icon: 'clipboard-minus',
        roles: [Admin],
      },
      {
        label: 'Intervenants',
        href: '/app/access-track/intervenants',
        icon: 'circle-user',
        roles: [Admin],
      },
    ],
  },
  {
    label: 'Rapport/Extraction',
    icon: 'table',
    items: [
      {
        label: 'Demande de credit',
        href: '/app/extraction/credit',
        icon: 'folder-open',
        roles: [...EXTRACTION_ROLES], // Aucune restriction dans l'ancien frontend
      },
      {
        label: 'Avance sur chèque',
        href: '/app/extraction/asc',
        icon: 'banknote-arrow-down',
        roles: [...EXTRACTION_ROLES], // Aucune restriction dans l'ancien frontend
      },
      {
        label: 'Garanties',
        href: '/app/extraction/garanties',
        icon: 'vault',
        roles: [...EXTRACTION_ROLES], // Aucune restriction dans l'ancien frontend
      },
    ],
  },
  {
    label: 'Paramètres',
    icon: 'sliders-horizontal',
    items: [
      {
        label: 'Utilisateurs',
        href: '/app/parametres/utilisateurs',
        icon: 'users',
        roles: [...PARAMS_ROLES],
      },
      {
        label: 'Configuration',
        href: '/app/parametres/configuration',
        icon: 'settings',
        roles: [...PARAMS_ROLES],
      },
    ],
  },
];
